
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.646 15.646a.5.5 0 000 .708l3.182 3.181a.5.5 0 10.708-.707L12.707 16l2.829-2.828a.5.5 0 10-.708-.708l-3.182 3.182zM24 15.5H12v1h12v-1z","fill":"#43B4EB"}}),_c('rect',{attrs:{"x":".5","y":".5","width":"35","height":"31","rx":"11.5","stroke":"#43B4EB"}})])
          )
        }
      }
    